import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Card, CardActionArea, CardContent, CardHeader, CardMedia, Typography, } from '@mui/material';
import AssetImage from '../common/asset/AssetImage';
const getImageAsset = (sectionItem) => {
    if (!sectionItem) {
        return undefined;
    }
    // console.log('sectionItem', sectionItem.type, sectionItem);
    if (sectionItem.type === 'microcast') {
        // console.log('microcastAsset');
        return sectionItem.microcast?.useAsPoster ? (sectionItem.microcast?.microcastImage) : sectionItem.microcast?.posterImage;
    }
    if (sectionItem.type === 'certification') {
        return sectionItem.certificateImage;
    }
    if (sectionItem.posterImage) {
        return sectionItem.posterImage;
    }
    return sectionItem.asset;
};
const UpNext = ({ nextSection, goToNextSection, }) => {
    if (!nextSection) {
        return null;
    }
    const image = getImageAsset(nextSection.item);
    return (_jsx(Card, { children: _jsxs(CardActionArea, { onClick: goToNextSection, children: [_jsx(CardHeader, { title: "UP NEXT", titleTypographyProps: {
                        sx: {
                            fontWeight: 600,
                            color: (t) => (t.portal.courseDeliveryPage?.notesBoxTextColor
                                || t.palette.contract.main),
                        },
                    } }), image && (_jsx(CardMedia, { children: _jsx(AssetImage, { asset: image, customStyle: { width: '100%', maxHeight: '200px', objectFit: 'cover' }, size: image.type === 'video' ? 'videoThumb' : 'thumb400w' }) })), _jsx(CardContent, { children: _jsx(Typography, { variant: "h5", children: nextSection?.name }) })] }) }));
};
export default observer(UpNext);
//# sourceMappingURL=UpNext.js.map